<template>
	<div class="app-top-bar__search-wrapper">
		<input
			class="app-top-bar__search"
			type="text"
			v-model="searchText"
			@input="filterSearching"
			placeholder="Search"
		/>
		<Icon type="search" color="#8E8E93" :size="30" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	data() {
		return {
			searchText: this.getSearchText,
		}
	},
	computed: {
		...mapGetters('app', ['getSearchMethods', 'getSearchText']),
	},
	methods: {
		...mapActions('app', ['clearSearchText']),
		filterSearching(e) {
			this.getSearchMethods(e.target.value)
		},
		clearInput() {
			this.searchText = ''
		},
	},
	watch: {
		$route() {
			this.clearInput()
		},
	},
}
</script>

<style lang="scss">
.app-top-bar {
	&__search-wrapper {
		position: relative;
		display: flex;
		flex-wrap: nowrap;
		flex-grow: 1;
		max-height: 40px;
		padding: 12px 10px;
		border-radius: 8px;
		max-width: 590px;

		@media (max-width: 1024px) {
			max-width: 274px;
		}

		@media (max-width: 768px) {
			max-width: none;
			background: #fff;
		}

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: var(--accent-color);
			mix-blend-mode: soft-light;
			border-radius: 8px;
			z-index: -1;
		}
	}

	&__search {
		flex-grow: 1;
		font-size: 16px;
		line-height: 19.5px;
		font-family: Montserrat, sans-serif;
		color: rgb(255, 255, 255);
		position: relative;

		&:focus {
			outline: none;
		}

		@media (max-width: 768px) {
			color: var(--accent-color);
		}
	}
}
</style>
